import { Radar, ExternalLink } from "lucide-react";

export function RadarMap({ spot }) {
  const lat = spot?.latitude ?? 45.78;
  const lon = spot?.longitude ?? 10.83;

  const src =
    `https://embed.windy.com/embed2.html?lat=${lat}&lon=${lon}` +
    `&detailLat=${lat}&detailLon=${lon}&zoom=10&level=surface&overlay=radar` +
    `&product=radar&menu=&message=true&marker=true&calendar=now&pressure=&type=map` +
    `&location=coordinates&detail=&metricWind=kt&metricTemp=%C2%B0C&radarRange=-1`;

  return (
    <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden" data-testid="radar-map">
      <div className="flex flex-wrap items-center gap-3 px-5 pt-5 pb-3">
        <div className="h-8 w-8 rounded-xl bg-sky-100 flex items-center justify-center">
          <Radar className="h-4 w-4 text-sky-600" />
        </div>
        <h3 className="font-head text-xl font-semibold text-slate-900">Radar precipitazioni · {spot?.name}</h3>
        <a
          href={`https://www.windy.com/-Radar-radar?radar,${lat},${lon},9`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="radar-full-link"
          className="ml-auto inline-flex items-center gap-1.5 text-xs font-semibold text-sky-600 hover:text-sky-700"
        >
          Apri intero <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
      <div className="w-full bg-slate-100 border-t border-slate-100">
        <iframe
          src={src}
          title={`Radar ${spot?.name}`}
          className="w-full"
          style={{ height: 460, border: 0 }}
          loading="lazy"
          data-testid="radar-iframe"
        />
      </div>
      <p className="text-[11px] text-slate-400 px-5 py-3">
        Radar pioggia live centrato sullo spot, senza pop-up. Premi play per l'animazione.
      </p>
    </div>
  );
}
